import React from 'react';
import { Grid, useTheme } from '@material-ui/core';
import MaterialTable from 'material-table';
import { useAppContext } from 'hooks/useAppContext';
import { Accident } from 'classes';
import { getAccidents } from 'utils/AccidentUtils';
import withAppStylesGrid from 'HOCs/withAppStyles';
import SkeletonGrid from 'components/Shared/SkeletonGrid';


function AccidentDataTable ({customFilter}) {
    const title = "Accidents";
    const theme = useTheme();
    const { selectedProject } = useAppContext();
    const columns = Accident.columns;
  
    const WrappedGrid = withAppStylesGrid(MaterialTable, { projectID: selectedProject, getRecords: getAccidents, theme, defaultFilters: { 
        ProjectId_WorkItem: selectedProject, 
          ...customFilter 
    }});
    
    return (
      selectedProject && theme ?
        <>
          <Grid container>
            <Grid item xs={12}>
              <WrappedGrid
                columns={columns}
                title={title}
                options={{
                  pageSize: 15,
                  pageSizeOptions: [15, 20, 25],
                  padding: 'dense'
                }}
              />
            </Grid>
           
          </Grid>
        </>
        : <SkeletonGrid title={title} />
    )
}

export default AccidentDataTable;